/**
 * POS back-office permission keys (catalog `pos.*`, docs/contracts/pos.md §6). Device keys (`pos.sale.create`, ...) are
 * checked by the terminal and re-checked at sync; the back office uses the keys below, which the API checks too.
 */
export const posPermissions = {
  profileView: "pos.profile.view",
  profileUpdate: "pos.profile.update",
  terminalView: "pos.terminal.view",
  terminalUpdate: "pos.terminal.update",
  terminalRevoke: "pos.terminal.revoke",
  devicePair: "pos.device.pair",
  shiftView: "pos.shifts.view",
  shiftPrint: "pos.shifts.print",
  shiftForceClose: "pos.shifts.update",
  shiftAdjustmentPost: "pos.shifts_adjustment.post",
  salesView: "pos.pos_sales.view",
  salesAnalysisView: "pos.sales_analysis.view",
  cashAuditView: "pos.cash_audit.view",
  drawerView: "pos.drawer_movement.view",
  syncIssueView: "pos.sync_issue.view",
  syncIssueResolve: "pos.sync_issue.resolve",
  overrideView: "pos.supervisor_override.view",
  branchOperationView: "pos.branch_operation.view",
} as const;

/** Plan module of the POS screens (P6). */
export const posModule = "pos";
